<template>
  <AdminConfirmModal
    v-model="getDeactivateCompanyModal"
    :message="$t('Tariffs.sure_want_deactivate_company')"
    :confirm-text="$t('Default.deactivate')"
    confirm-color="sub white--text"
    cancel-color="main_color white--text"
    @confirm="deactivate"
  />
</template>
<script>
import { shortComputed } from "@/utility/helpers";
import { useStore } from "vuex-composition-helpers";
import { globalVariables } from "@/utility/variables";
import { GlobalMutationTypes } from "@/store/modules/global/types";
import companyInstance from "@/services/api/company";
import AdminConfirmModal from "@/components/partials/Admin/AdminConfirmModal.vue";

export default {
  components: { AdminConfirmModal },
  props: ["currentCompany", "onSuccess"],
  setup(props, { root }) {
    const store = useStore();
    const { userInfo } = globalVariables();

    const getDeactivateCompanyModal = shortComputed(
      {
        storeType: "global",
        key: "getDeactivateCompanyModal",
      },
      GlobalMutationTypes.setDeactivateCompanyModal
    );

    const deactivate = () => {
      companyInstance.deactivateCompany(props.currentCompany.id).then((res) => {
        store.commit(GlobalMutationTypes.setDeactivateCompanyModal, false);
        props.onSuccess();
      });
    };

    return {
      store,
      userInfo,
      getDeactivateCompanyModal,
      deactivate,
    };
  },
};
</script>
